import script from "./SocialConsentGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialConsentGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./SocialConsentGuideModal.vue?vue&type=style&index=0&id=6b74cba8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b74cba8"]])

export default __exports__